import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = {
  domain: '',
  name: '',
  settings: {
    reservation_identity: {
      logo: '',
      preserving_rights: '',
      page_icon: '',
    },
    reservation_info: {
      about_activity_en: '',
      about_activity_ar: '',
      added_facebook: '',
      facebook: '',
      added_instagram: '',
      instagram: '',
      added_twitter: '',
      twitter: '',
      added_tiktok: '',
      tiktok: '',
      added_snapchat: '',
      snapchat: '',
      added_whatsapp_number: '',
      whatsapp_number: '',
      added_email: '',
      email: '',
      added_phone: '',
      phone_number: '',
    },
    reservation_cancellation_policy: {},
  },
};

export const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenantDomain: (state, { payload: { domain } }) => {
      return { ...state, domain };
    },
    setTenantData: (state, { payload: { name, settings } }) => {
      return { ...state, name, settings };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTenantDomain, setTenantData } = tenantSlice.actions;

export const getTenant = (state: RootState) => state.tenant;

export default tenantSlice.reducer;
